<template>
  <div
    id="detail-layout"
    hidden
  >
    <Login />
    <glh-header />
    <section class="box">
      <nuxt />
    </section>
    <glh-footer />
  </div>
</template>
<script>
import glhFooter from "~/components/public/glh-footer";
import glhHeader from "~/components/public/glh-header";
import Login from "~/components/public/login";

export default {
  components: {
    glhFooter,
    glhHeader,
    Login
  },
  mounted() {
    this.$el.removeAttribute('hidden')
  }
};
</script>

<style lang="less" scoped>
section.box {
  padding-top: 120px;
  background-color: #f8f8f8; // background-color: #df5151
}
</style>
